export const INE_URL = process.env.REACT_APP_PUBLIC_URL;
export const BUSINESS_URL = process.env.REACT_APP_BUSINESS_PUBLIC_URL;
export const ACCOUNT_MANAGEMENT_DOMAINS = ['ine.com'];
